"use client"

import { useState } from "react"
import "./CAFaq.css"

const faqData = [
  {
    question: "What is Code review?",
    answer:
      "Code review, also known as peer code review, is the deliberate and methodical gathering of programmers to examine each other's code for errors. It has been consistently demonstrated that code review may speed up and simplify software development, unlike other techniques. Software and methods for peer code review exist, but it's crucial to comprehend the idea behind it. Software is created by people. As a result, that same software is frequently filled with errors; this is a clear association because it is human nature to make mistakes. What is less evident is why software engineers often omit using that other great asset of human nature - the capacity to recognise and fix errors - in favour of manual or automated testing to validate their code.",
  },
  {
    question: "How do you conduct a code review?",
    answer:
      "Code reviews or software audit services are all automated checks but before the working branch is merged with the main branch (source code). There are at least two functions in the code review procedure. Authors are those who write the code and submit Pull Requests, while reviewers are those who go at the code.We advise you to follow these steps if you want to perform a review on your own:• Understand what you want from a code review• Recognize the many approaches to a code review• Hold frequent group sessions so participants may get notes about any difficulties as well as comments on their specific areas• Make remarks that are precise and clear• Be willing to improve• Be accessible for conversations• Start with simple adjustments, then go over more involved ones• Update the commit's status often.",
  },
  {
    question: "What is the purpose of a code audit?",
    answer:
      "A Code audit is an integral part of the software development lifecycle. It allows developers to improve code quality dramatically.The process is like writing a book. The writer creates the story, and the editor reviews it, so there aren't any errors. In this case, it's the act of reading and evaluating other people's code. The purpose is to find areas of improvement or bugs that might otherwise go unnoticed at an early stage and get in the way of your product's performance. The code review process typically happens before merging with the codebase.",
  },
]

const ScopingFAQ = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section6532">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title">CODE AUDIT</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingFAQ;
